export default "__VITE_PUBLIC_ASSET__e860a493__"